import React from "react";
import { Nav } from "@caesars-ui/core"
import { useDispatch, useSelector } from "react-redux";
import { setPlatform, platformSelector } from "~/state/globalSlice";

const items = [{
    id: 0,
    label: "Web (CSS)"
},{
    id: 1,
    label: "Tailwind"
},{
    id: 2,
    label: "iOS"
},{
    id: 3,
    label: "Android"
}]


const PlatformSwitcher = ({handleToggle, ...rest}) => {
    const dispatch = useDispatch();
    const platform = useSelector(platformSelector);
    const handleActiveItem = (id)=>{ 
        const [selectedItem] = items.filter(i => i.id === id)
        dispatch(setPlatform(selectedItem.label))
    }
    const activeItem = items.filter(item => item.label === platform)[0].id;
    return <Nav items={items} initialActive={activeItem}
    onActiveItem={handleActiveItem} variant="pill" size="md" simple {...rest} />
}

export default PlatformSwitcher;